import { render, staticRenderFns } from "./orderProgress.vue?vue&type=template&id=2efa8522&scoped=true&"
import script from "./orderProgress.vue?vue&type=script&lang=js&"
export * from "./orderProgress.vue?vue&type=script&lang=js&"
import style0 from "./orderProgress.vue?vue&type=style&index=0&id=2efa8522&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efa8522",
  null
  
)

export default component.exports